<template lang="pug">
    div(class="caption font-weight-bold primary--text")                                          
        v-radio-group(dense v-model="type" @change="onSelect" :readonly="readonly" row)
            v-radio(label="Debet Kredit" value="DBCR" color="primary" )
            v-radio(label="Debet Keseluruhan" value="DB_FULL" color="primary")
</template>
<script>
export default {
    name: "FRadioVirtualAccountType",
    props: ["value","readonly"],
    data() {
        return {
            type: null
        };
    },
    mounted() {
        this.doInitModel(this.value);
    },
    watch: {
        value(val) {
            this.doInitModel(val);
        }
    },
    methods: {
        doInitModel(values) {
            this.type = values;
            this.onSelect();
        },
        onSelect() {
            this.$emit("input", this.type);
            this.$emit("select", this.type);
        }
    }
};
</script>